import {Injectable} from '@angular/core';
import {map} from "rxjs/operators";
import {plainToInstance} from "class-transformer";
import {BehaviorSubject, Observable} from "rxjs";
import {HelpSidebarComponent} from "./help-sidebar/help-sidebar.component";
import {HelpModel} from "./help.model";
import {MesApiService} from "../mes-api.service";
import {DomService} from "../dom.service";
import {LocalizationModel} from "../system/languages/localization.model";
import {ApiResponse} from "../api-response/api-response.model";

@Injectable({
  providedIn: 'root'
})
export class HelpService extends MesApiService {
  private isSidebarOpen: boolean = false;
  public isEditMode: boolean = false;
  public hasBaseVersion: boolean = false;
  public topic$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  constructor(private domService: DomService) {
    super('help');
  }

  addKeys(keys: string[]): Observable<LocalizationModel[]> {
    return this.add([...new Set(keys)], {action: 'AddKeys'}).pipe(map(value => {
      return plainToInstance(LocalizationModel, value.data);
    }));
  }

  getTopics(): Observable<LocalizationModel[]> {
    return this.getList({action: 'GetTopics'}).pipe(map(value => {
      return plainToInstance(LocalizationModel, value.data);
    }));
  }

  getTopic(key: string): Observable<LocalizationModel> {
    return this.getSingle({action: 'GetTopic'}, {key: key}).pipe(map(value => {
      return plainToInstance(LocalizationModel, value.data);
    }));
  }

  getHelp(key: string, insistCore: boolean = null) {
    return this.getSingle<HelpModel>({action: 'Get'}, {key: key, insistCore: insistCore}).pipe(map(value => {
      return plainToInstance(HelpModel, value.data);
    }));
  }

  getHelpById(id: string, insistCore: boolean = null) {
    return this.getSingle<HelpModel>({action: 'GetById', id: id}, {insistCore: insistCore}).pipe(map(value => {
      return plainToInstance(HelpModel, value.data);
    }));
  }

  save(help: HelpModel) {
    return this.add(help, {action: 'Save'}).pipe(map(value => {
      return plainToInstance(HelpModel, value.data);
    }));
  }

  upload(blobInfo: any): Observable<ApiResponse<string>> {
    return this.add(blobInfo, {action: 'Upload'});
  }

  openTopic(topic: string) {
    this.ensureSideBarOpen();
    this.topic$.next(topic);
  }

  private ensureSideBarOpen() {
    if (!this.isSidebarOpen) {
      this.domService.appendComponentToBody(HelpSidebarComponent);
      this.isSidebarOpen = true;
    }
  }

  closeSidebar() {
    this.isSidebarOpen = false
  }
}
